import React from 'react'
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import BoxWithIcon from "../../atoms/ComponentBox/BoxWithIcon";
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectPermissions } from '../../redux/permissionsSlice';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const Checkoutduespage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const permissions = useSelector(selectPermissions);

  const hasModulePermission = (moduleName) => {
    const modulePermission = permissions.find(
      permission => permission.ModuleName === moduleName
    );

    if (!modulePermission) return false;

    return (
      modulePermission.AddRec === "1" ||
      modulePermission.EditRec === "1" ||
      modulePermission.DeleteRec === "1" ||
      modulePermission.ViewRec === "1"
    );
  };

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container sx={{
          width: "100%",
          maxWidth: "100%"
        }}>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              {hasModulePermission("Checkout Request") && (
                <BoxWithIcon
                  totalCount={10}
                  activeCount={10}
                  inactiveCount={0}
                  link={{ pathname: '/checkout/checkoutrequesttable' }}
                  permissions={permissions}
                  title="Checkout Request"
                />
              )}
              {hasModulePermission("Checkout Article Handover") && (
                <BoxWithIcon
                  totalCount={10}
                  activeCount={10}
                  inactiveCount={0}
                  link={{ pathname: '/checkout/checkoutarticaltable' }}
                  permissions={permissions}
                  title="Checkout Article Handover"
                />
              )}
              {hasModulePermission("Checkout Approval") && (
                <BoxWithIcon
                  totalCount={10}
                  activeCount={10}
                  inactiveCount={0}
                  link={{ pathname: '/checkout/checkoutaprvtable' }}
                  permissions={permissions}
                  title="Checkout Approval"
                />
              )}
              {hasModulePermission("Checkout Dues") && (
                <BoxWithIcon
                  totalCount={10}
                  activeCount={10}
                  inactiveCount={0}
                  link={{ pathname: '/checkout/checkoutduetable' }}
                  permissions={permissions}
                  title="Checkout Dues"
                />
              )}
              {hasModulePermission("Checkout") && (
                <BoxWithIcon
                  totalCount={10}
                  activeCount={10}
                  inactiveCount={0}
                  link={{ pathname: '/checkout/CheckoutTable' }}
                  permissions={permissions}
                  title="Checkout"
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Checkoutduespage;